<template>
  <div class="userAgreement modelPage">
    <navbar :nav="nav"></navbar>
    <div class="contentText">
      <h3 style="padding-top: 10px;"><span>利用規約</span></h3>
      <p>
        この利用規約（以下、「本規約」といいます。）は、ニューラルマーケティング株式会社（以下、「当社」といいます。）がこのウェブサイト上で提供するサービス（以下、「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下、「ユーザー」といいます。）には、AI生成画像の著作権に関する注意を確認した上、本規約に従って、本サービスをご利用いただきます。
      </p>
      <h3>第1条（適用）</h3>
      <p>
        1、本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
      </p>
      <p>
        2、当社は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下、「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。
      </p>
      <p>
        3、本規約の規定が前条の個別規定の規定と矛盾する場合には、個別規定において特段の定めなき限り、個別規定の規定が優先されるものとします。
      </p>
      <h3>第2条（利用登録）</h3>
      <p>
        1、本サービスにおいては、登録希望者が本規約に同意の上、当社の定める方法によって利用登録を申請し、当社がこれを承認することによって、利用登録が完了するものとします。
      </p>
      <p>
        2、当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
      </p>
      <p>a.利用登録の申請に際して虚偽の事項を届け出た場合</p>
      <p>b.本規約に違反したことがある者からの申請である場合</p>
      <p>c.その他、当社が利用登録を相当でないと判断した場合</p>
      <h3>第3条（ユーザーIDおよびパスワードの管理）</h3>
      <p>
        1、ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理するものとします。
      </p>
      <p>
        2、ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
        ユーザーID及びパスワードが第三者によって使用されたことによって生じた損害は、当社に故意又は重大な過失がある場合を除き、当社は一切の責任を負わないものとします。
      </p>
      <h3>第4条（生成画像の保管）</h3>
      <p>1、本ツールは、利用者が生成した画像やイラストを30日間保管します。</p>
      <p>
        2、30日間を経過した後、生成された画像やイラストは自動的に削除されます。
      </p>
      <h3>第5条（利用料金および支払方法）</h3>
      <p>
        ユーザーは、本サービスの有料部分の対価として、当社が別途定めた、本ウェブサイトに表示する利用料金を、当社が指定する方法により支払うものとします。
      </p>
      <h3>第6条（禁止事項）</h3>
      <p>
        ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
      </p>
      <p>1、法令または公序良俗に違反する行為</p>
      <p>2、犯罪行為に関連する行為</p>
      <p>
        3、本サービスの内容等、本サービスに含まれる著作権、商標権ほか知的財産権を侵害する行為、本サービスを利用して他者の知的財産権を侵害する行為当社、ほかのユーザー、またはその他第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
      </p>
      <p>4、当社のサービスの運営を妨害するおそれのある行為</p>
      <p>5、不正アクセス、またはこれを試みる行為</p>
      <p>6、他のユーザーに関する個人情報等を収集または蓄積する行為</p>
      <p>7、不正な目的を持って本サービスを利用する行為</p>
      <p>
        8、本サービスを利用する他のユーザーまたはその他の第三者に不利益、損害、不快感を与える行為
      </p>
      <p>9、他のユーザーに成りすます行為</p>
      <p>
        10、当社が許諾しない本サービス上での宣伝、広告、勧誘、または営業行為
      </p>
      <p>
        11、当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
      </p>
      <p>12、その他、当社が不適切と判断する行為</p>

      <h3>第7条（本サービスの提供の停止等）</h3>
      <p>
        1、当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします
      </p>
      <p>
        a.本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
      </p>
      <p>
        b.地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合
      </p>
      <p>c.コンピュータまたは通信回線等が事故により停止した場合</p>
      <p>d.その他、当社が本サービスの提供が困難と判断した場合</p>
      <p>
        2、当社は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害についても、一切の責任を負わないものとします。
      </p>
      <h3>第8条（利用制限および登録抹消）</h3>
      <p>
        1、当社は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーに対して、本サービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。
      </p>
      <p>a.本規約のいずれかの条項に違反した場合</p>
      <p>b.登録事項に虚偽の事実があることが判明した場合</p>
      <p>c.料金等の支払債務の不履行があった場合</p>
      <p>d.当社からの連絡に対し、一定期間返答がない場合</p>
      <p>e.本サービスについて、最終の利用から一定期間利用がない場合</p>
      <p>f.その他、当社が本サービスの利用を適当でないと判断した場合</p>
      <p>
        2、当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
      </p>
      <h3>第9条（退会）</h3>
      <p>
        ユーザーは、当社の定める退会手続により、本サービスから退会できるものとします。
      </p>
      <h3>第10条（保証の否認および免責事項）</h3>
      <p>
        1、当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
      </p>
      <p>
        2、当社は、本サービスに起因してユーザーに生じたあらゆる損害について、当社の故意又は重過失による場合を除き、一切の責任を負いません。ただし、本サービスに関する当社とユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
      </p>
      <p>
        3、前項ただし書に定める場合であっても、当社は、当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し、または予見し得た場合を含みます。）について一切の責任を負いません。また、当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害の賠償は、ユーザーから当該損害が発生した月に受領した利用料の額を上限とします。
      </p>
      <p>
        4、当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
      </p>
      <h3>第11条（サービス内容の変更等）</h3>
      <p>
        当社は、ユーザーへの事前の告知をもって、本サービスの内容を変更、追加または廃止することがあり、ユーザーはこれを承諾するものとします。
      </p>
      <h3>第12条（利用規約の変更）</h3>

      <p>
        1、当社は以下の場合には、ユーザーの個別の同意を要せず、本規約を変更することができるものとします。
      </p>
      <p>a.本規約の変更がユーザーの一般の利益に適合するとき。</p>
      <p>
        b.本規約の変更が本サービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。
      </p>
      <p>
        2、当社はユーザーに対し、前項による本規約の変更にあたり、事前に、本規約を変更する旨及び変更後の本規約の内容並びにその効力発生時期を通知します。
      </p>
      <h3>第13条（個人情報の取扱い）</h3>
      <p>
        当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱うものとします。
      </p>
      <h3>第14条（通知または連絡）</h3>
      <p>
        ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。当社はユーザーから、当社が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは発信時にユーザーへ到達したものとみなします。
      </p>
      <h3>第15条（権利義務の譲渡の禁止）</h3>
      <p>
        ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。
      </p>
      <h3>第16条（準拠法・裁判管轄）</h3>
      <p>1、本規約の解釈にあたっては、日本法を準拠法とします。</p>
      <p>
        2、本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
      </p>
      <h3><span>著作権</span></h3>
      <p>
        1、本サービスのテキストデータ生成機能は、既存のAI技術の制約に従っており、入力文章の構成や不適切な単語、AIの性能により、常に正確な画像データを生成できるとは限りません。したがって、当社は正確性を保証いたしません。
      </p>
      <p>
        2、生成された画像データの著作権、その使用、制限等に関しては、[OpenAI](https://openai.com/policies)の規約に従います。
      </p>
      <p>
        3、現在、AIによって生み出される作品の著作権に関する問題は未解決であり、各国によって異なる規制が存在しています。
      </p>
      <p>
        本サービスではサービス内で作成された画像がお客様オリジナルの著作物であることを保証しません。つまり、お客様が本サービスで作成したイメージそのものについての権利はお客様にありますが、これは排他的な権利を持つものではないことを意味し、また、本サービスで生成されたイメージの著作物性を保証するものではないことを意味します。
      </p>
      <p>
        4、利用規約により、お客様は自分が作成したイメージを自分のコンテンツに使用し、本サービスを製品のマーケティングに使用することを許可していますが、これはあくまで使用許可であり、著作権所有者であることを意味するものではありません。
      </p>
      <p>
        5、本サービスを使用して認識可能なキャラクターやブランドを作成する場合、これらは著作権や商標で保護されている可能性があります。したがって、生成画像等の基となって原著作者の許可を得ずにこれらの画像を使用することは違法です。本サービス自体が原著作者の許可を与えることはできません。
      </p>
      <p>
        6、本サービスによって利用者が送信するテキストデータから画像への変換については、当社の意思に基づいて利用、加工、複製、翻案等を行うものではなく、本サービスのAI機能によって機械的に行われるだけです。したがって、当該テキストまたは画像の著作権、商標権、肖像権、その他の知的財産権、その他の権利の保護について、当社は関与しませんし保証も行いません。このため、利用者は自己責任で本サービスを利用するものとし、本サービスの利用により第三者の権利侵害が発生した場合でも、利用者自らが責任と費用を負担し、当社は一切の責任を負いません。
      </p>
      <h3><span>プライバシーポリシー</span></h3>
      <p>
        ニューラルマーケティング株式会社（以下、「当社」といいます。）は、本ウェブサイト上で提供するサービス（以下,「本サービス」といいます。）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
      </p>
      <h3>第1条（個人情報）</h3>
      <p>
        「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
      </p>
      <h3>第2条（個人情報の収集方法）</h3>

      <p>
        当社は、お客様が弊社のサービスを利用された場合、以下の方法を通じて個人情報を収集することがあります。
      </p>
      <p>
        1、登録フォーム/契約情報：弊社との契約時及び、当サービスの利用登録時に、お客様から氏名、生年月日、住所、電話番号、メールアドレス、銀行口座番号、クレジットカード番号、運転免許証番号などの個人情報を収集する場合があります。
      </p>
      <p>
        2、ツール内でお客様が提供した情報：サービスの提供やお問い合わせなど、弊社との対話中にお客様が自発的に個人情報を提供される場合があります。
      </p>
      <p>
        3、自動データ収集技術：弊社は、サービスの利用に関連する情報として、使用状況データ（IPアドレス、デバイス情報など）を自動的に収集する場合があります。これは、ウェブサイトへのアクセスログやアプリの使用履歴などを含みます。
      </p>
      <p>
        これらの収集方法により、お客様の個人情報を適切に取得しております。個人情報の取り扱いについては、プライバシーポリシーや利用規約に詳細な情報が記載されていますので、お客様には事前にこれらの情報をご確認いただくようお願いいたします。お客様の個人情報保護に最大限の注意を払い、信頼性のあるサービスを提供するため努めております。
      </p>

      <h3>第3条（個人情報を収集・利用する目的）</h3>

      <p>当社が個人情報を収集・利用する目的は、以下のとおりです。</p>
      <p>1、当社サービスの提供・運営のため</p>
      <p>
        2、ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）
      </p>
      <p>
        3、ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等及び当社が提供する他のサービスの案内のメールを送付するため
      </p>
      <p>4、メンテナンス、重要なお知らせなど必要に応じたご連絡のため</p>
      <p>
        5、利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため
      </p>
      <p>
        6、ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため
      </p>
      <p>7、有料サービスにおいて、ユーザーに利用料金を請求するため</p>
      <p>8、上記の利用目的に付随する目的</p>
      <h3>第4条（利用目的の変更）</h3>
      <p>
        1、当社は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。
      </p>
      <p>
        2、利用目的の変更を行った場合には、変更後の目的について、当社所定の方法により、ユーザーに通知し、または本ウェブサイト上に公表するものとします。
      </p>
      <h3>第5条（個人情報の第三者提供）</h3>
      <p>
        1、当社は、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
      </p>
      <p>
        a.人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
      </p>
      <p>
        b.公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
      </p>
      <p>
        c.国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
      </p>
      <p>
        d.予め次の事項を告知あるいは公表し、かつ当社が個人情報保護委員会に届出をしたとき
      </p>
      <p>i.利用目的に第三者への提供を含むこと</p>
      <p>ii.第三者に提供されるデータの項目</p>
      <p>iii.第三者への提供の手段または方法</p>
      <p>iv.本人の求めに応じて個人情報の第三者への提供を停止すること</p>
      <p>v.本人の求めを受け付ける方法</p>
      <p>
        2、前項の定めにかかわらず、次に掲げる場合には、当該情報の提供先は第三者に該当しないものとします。
      </p>
      <p>
        a.当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
      </p>
      <p>b.合併その他の事由による事業の承継に伴って個人情報が提供される場合</p>
      <p>
        c.個人情報を特定の者との間で共同して利用する場合であって、その旨並びに共同して利用される個人情報の項目、共同して利用する者の範囲、利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について、あらかじめ本人に通知し、または本人が容易に知り得る状態に置いた場合
      </p>
      <h3>第6条（個人情報の開示）</h3>

      <p>
        1、当社は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
      </p>
      <p>
        a.本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
      </p>
      <p>b.当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</p>
      <p>c.その他法令に違反することとなる場合</p>
      <p>
        2、前項の定めにかかわらず、履歴情報および特性情報などの個人情報以外の情報については、原則として開示いたしません。
      </p>
      <h3>第7条（個人情報の訂正および削除）</h3>
      <p>
        1、ユーザーは、当社の保有する自己の個人情報が誤った情報である場合には、当社が定める手続きにより、当社に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。
      </p>
      <p>
        2、当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
      </p>
      <p>
        3、当社は、前項の規定に基づき訂正等を行った場合、または訂正等を行わない旨の決定をしたときは遅滞なく、これをユーザーに通知します。
      </p>
      <h3>第8条（個人情報の利用停止等）</h3>
      <p>
        1、当社は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下、「利用停止等」といいます。）を求められた場合には、遅滞なく必要な調査を行います。
      </p>
      <p>
        2、前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。
      </p>
      <p>
        3、当社は、前項の規定に基づき利用停止等を行った場合、または利用停止等を行わない旨の決定をしたときは、遅滞なく、これをユーザーに通知します。
      </p>
      <p>
        4、前2項にかかわらず、利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、ユーザーの権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じるものとします。
      </p>
      <h3>第9条（プライバシーポリシーの変更）</h3>
      <p>
        1、本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。
      </p>
      <p>
        2、当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
      </p>
      <h3>第10条（お問い合わせ窓口）</h3>
      <p>本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。</p>
      <p class="notText"></p>
      <p>住所：〒558-0047 大阪府大阪市住吉区千躰2-2-24</p>
      <p>社名：ニューラルマーケティング株式会社</p>
      <p>担当部署：カスタマーサポート（お客様相談窓口）</p>
      <p>Eメールアドレス：support@neuralmarketing.co.jp</p>
    </div>
  </div>
</template>

<script>
import navbar from "../../components/navbar/index.vue";
export default {
  components: {
    navbar
  },
  data() {
    return {
      nav: {
        back: true,
        title: "利用規約、著作権、およびプライバシーポリシー",
        chat: false
      }
    };
  },
  methods: {
    onClickLeft() {
      this.$router.back(1);
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style>
.aiCenter .userAgreement .van-nav-bar__left,
.aiCenter .userAgreement .vanNavBarLefttitle {
  width: 100%;
}
.contentText h3 span {
  display: block;
  text-align: center;
  text-decoration: underline;
  padding: 0 0 20px 0;
}
.modelPage.userAgreement .contentText h3 {
  padding: 24px 0 6px 0;
}
.modelPage.userAgreement .contentText p {
  /* padding: 2px 0; */
  line-height: 26px;
}
.modelPage.userAgreement .contentText .notText {
  height: 22px;
}
@media screen and (min-width: 1439px) {
  .contentText h3 span {
    padding: 0 0 20px 0; /* no*/
  }
  .modelPage.userAgreement .contentText h3 {
    padding: 24px 0 6px 0; /* no*/
  }
  .modelPage.userAgreement .contentText p {
    /* padding: 2px 0; */
    line-height: 26px; /* no*/
  }
  .modelPage.userAgreement .contentText .notText {
    height: 16px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/model/userAgreement.vue